require('./brokerAlertsConfigDefault.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { formatText } = require('core/i18n').i18n;

// @component
const BrokerConfigDefaultItem = require('components/broker/brokerConfigDefaultItem/brokerConfigDefaultItem');

class BrokerAlertsConfigDefault extends React.Component {
    buildItems() {
        const items = this.props.alerts.toJS();

        return items.map( (item, index) => {
            return <BrokerConfigDefaultItem text={item.text} key={index} />;
        });
    }

    render() {
        const { hideAlterts } = this.props;
        const items = this.buildItems();
        const title = formatText('broker-alertsConfigPerDefault');

        return !hideAlterts && (
            <div className="broker-alerts-config-default no-print-out">
                <h3 className="broker-alerts-config-default__subtitle">{title}</h3>
                <div className="broker-alerts-config-default__container">
                    {items}
                </div>
            </div>
        );
    }
}

BrokerAlertsConfigDefault.propTypes = {
    alerts: PropTypes.object.isRequired,
    hideAlterts: PropTypes.bool
};

BrokerAlertsConfigDefault.defaultProps = {
    hideAlterts: false
}

module.exports = BrokerAlertsConfigDefault;
